import * as serverReq from "./selectedUserCrud";
import {selectedUserSlice} from "./selectedUserSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = selectedUserSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  if (error?.message && error.message === "Cancel Request" ) return;
  dispatch(actions.userNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.userNotification({notification: null}));

/* Load User Profile Handler */
export const fetchUserProfile = userId => dispatch => {
  serverReq.getUserProfile(userId)
            .then(({data}) =>  dispatch(actions.userProfileFetched({ ...data })))
            .catch(errorHandler(dispatch));
};

/* Update selected user Profile Handler */
export const updateUserProfile = (userId, userData) => dispatch => {
  dispatch(actions.isLoading());
  serverReq.updateUserProfile(userId, userData)
            .then(({data}) => dispatch(actions.userProfileUpdated({...data})))
            .catch(errorHandler(dispatch));
};

/* Delete existing user Handler */
export const deleteUser = userId => dispatch => {
  serverReq.deleteUser(userId)
            .then(({data}) => dispatch(actions.userDeleted({ ...data })))
            .catch(errorHandler(dispatch));
};


/**********************************************************************
 * 
 * ACCOUNT HANDLERS
 * 
 *************************************************************************************************************/

/* Load User Accounts Handler */
export const fetchUserAccounts = userId => dispatch => {
  serverReq.getUserAccounts(userId)
            .then(({data}) =>  dispatch(actions.userAccountsFetched([...data])))
            .catch(errorHandler(dispatch));
};

/* Load User Account Details Handler */
export const fetchUserAccountDetails = (userId, accountId) => dispatch => {
  serverReq.getUserAccountDetails(userId, accountId)
            .then(({data}) =>  dispatch(actions.userAccountDetailsFetched({accountId, data})))
            .catch(errorHandler(dispatch));
};

/* Create Trading Account for the User */
export const createTradingAccount = (userId, accountData) => dispatch => {
  dispatch(actions.toggleShowCreateAccountModal());
  serverReq.createTradingAccount(userId, accountData)
            .then(({data}) => {  
              dispatch(fetchUserAccounts(userId));
              dispatch(actions.tradingAccountCreated({...data}));
            })
            .catch(errorHandler(dispatch));
};

/* Create Reserved Account for the User */
export const createReserveAccount = (userId, accountId, data) => dispatch => {
  serverReq.createReserveAccount(userId, accountId, data)
            .then(({data}) =>  dispatch(actions.reserveAccountCreated({...data})))
            .catch(errorHandler(dispatch));
};

/* update Reserved Account Instant Status for the User */
export const updateReserveAccountInstant = (userId, accountId, data) => dispatch => {
  serverReq.updateReserveAccountInstant(userId, accountId, data)
            .then(({data}) =>  dispatch(actions.reserveAccountInstantUpdated({...data})))
            .catch(errorHandler(dispatch));
};

/* Cancel Account Order for the User */
export const cancelAccountOrder = (orderId, meta) => dispatch => {
  serverReq.cancelAccountOrder(orderId, meta)
            .then(({data}) =>  dispatch(actions.accountOrderCancelled({...data})))
            .catch(errorHandler(dispatch));
};

/* Get instruments */
export const getSearchInstruments = (query, provider) => dispatch => {
  dispatch(actions.isLoading());
  serverReq.getSearchInstruments(query, provider)
            .then(({data}) =>  dispatch(actions.instrumentsFetched({data})))
            .catch(e => {
              dispatch(actions.instrumentsFetched({data: []}));
              errorHandler(dispatch)(e);
            });
};

/* Get instruments Details */
export const getInstrumentDetails = (instrumentId) => dispatch => {
  dispatch(actions.isLoading());
  serverReq.getInstrumentDetails(instrumentId)
            .then(({data}) =>  dispatch(actions.instrumentDetails({data})))
            .catch(e => {
              dispatch(actions.instrumentDetails({data: null}));
              errorHandler(dispatch)(e);
            });
};

/* Create Order Action */
export const createOrder = data => dispatch => {
  dispatch(actions.isLoading());
  serverReq.createOrder(data)
            .then(({data}) =>  dispatch(actions.orderActionCreated({...data})))
            .catch(errorHandler(dispatch));
};

/* Create Withdrawal */
export const createWithdrawal = data => dispatch => {
  serverReq.createWithdrawal(data)
            .then(({data}) =>  dispatch(actions.withdrawalCreated({...data})))
            .catch(errorHandler(dispatch));
};

/* Download Statement */
export const downloadStatement = (userId, accountId, key, name) => dispatch => {
  serverReq.downloadStatement(userId, accountId, key)
            .then(({data}) =>  {
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `${name}.pdf`);
              document.body.appendChild(link);
              link.click();
            })
            .catch(errorHandler(dispatch));
}


/**********************************************************************
 * 
 * DOCUMENT HANDLERS
 * 
 *************************************************************************************************************/

/* Load User Documents Handler */
export const fetchUserDocuments = userId => dispatch => {
  serverReq.getUserDocuments(userId)
            .then(({data}) =>  dispatch(actions.userDocumentsFetched([...data])))
            .catch(errorHandler(dispatch));
};
/* Upload User Document Handler */
export const uploadUserDocument = (userId, docData) => dispatch => {
  serverReq.uploadUserDocument(userId, docData)
            .then(({data}) =>  dispatch(actions.userDocumentUploaded({...data})))
            .catch(errorHandler(dispatch));
};

/**********************************************************************
 * 
 * BANK ACCOUNT HANDLERS
 * 
 *************************************************************************************************************/

/* Load Banks */
export const fetchBanks = _ => dispatch => {
  dispatch(actions.isLoading());
  serverReq.getBanks()
            .then(({data}) =>  dispatch(actions.banksFetched([...data])))
            .catch(errorHandler(dispatch));
};

/* Load User Bank Accounts Handler */
export const fetchUserBankAccounts = userId => dispatch => {
  serverReq.getUserBankAccounts(userId)
            .then(({data}) =>  dispatch(actions.userBankAccountsFetched([...data])))
            .catch(errorHandler(dispatch));
};

/* Get Bank Account Name */
export const fetchBankAccountName = (bankRef, accountNumber) => dispatch => {
  dispatch(actions.bankAccountNameFetched(null));
  setTimeout(_ => dispatch(actions.isLoading()), 200);
  serverReq.getBankAccountName(bankRef, accountNumber)
            .then(({data}) =>  dispatch(actions.bankAccountNameFetched({...data})))
            .catch(errorHandler(dispatch));
};

/* Add Bank Account */
export const addNewBankAccount = bankAccountData => dispatch => {
  dispatch(actions.bankAccountNameFetched(null));
  serverReq.addNewBankAccount(bankAccountData)
            .then(({data}) =>  dispatch(actions.bankAccountAdded({...data})))
            .catch(errorHandler(dispatch));
};

/* Delete Bank Account */
export const deleteBankAccount = (userId, ref, data) => dispatch => {
  serverReq.deleteBankAccount(userId, ref, data)
            .then(({data}) =>  dispatch(actions.bankAccountDeleted({...data})))
            .catch(errorHandler(dispatch));
};



/**********************************************************************
 * 
 * SAVED CARD HANDLERS
 * 
 *************************************************************************************************************/

/* Load User Documents Handler */
export const fetchUserSavedCards = userId => dispatch => {
  serverReq.getUserSavedCards(userId)
            .then(({data}) =>  dispatch(actions.userSavedCardsFetched([...data])))
            .catch(errorHandler(dispatch));
};

/* Delete Saved Card */
export const deleteSavedCard = (userId, cardId, data) => dispatch => {
  serverReq.deleteSavedCard(userId, cardId, data)
            .then(({data}) =>  dispatch(actions.savedCardDeleted({...data})))
            .catch(errorHandler(dispatch));
};

/**********************************************************************
 * 
 * EARN HANDLERS
 * 
 *************************************************************************************************************/

/* Load User Safe Lock Handler */
export const fetchUserSafeLocks = email => dispatch => {
  serverReq.getUserSafeLocks(email)
            .then(({data}) =>  dispatch(actions.userSafeLocksFetched({...data})))
            .catch(errorHandler(dispatch));
            
};

/* Load User Liquidations Handler */
export const fetchUserLiquidations = email => dispatch => {
  serverReq.getUserLiquidations(email)
            .then(({data}) =>  dispatch(actions.userLiquidationsFetched({...data})))
            .catch(errorHandler(dispatch));
            
};




